import React, { createContext, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { secondAxios } from "../../../../../../../../api/axios";

import { fetchMrqThenBidData } from "./fetchMrqThenBidData";

const BidContext = createContext({
  vendors: [],
  setVendors: () => {},

  openChatVendorIndex: [],
  setOpenChatVendorIndex: () => {},
});

export const useBidContext = () => useContext(BidContext);

function BidContextProvider({ children }) {
  // Standalone Vendor Bid Evaluation page: the MRQ comes from the route
  // (/plant/:plantId/bid/:bidId) instead of the MCS page's "mrq-id" hash,
  // and the plant is fetched here instead of read from mcsContext. Its
  // `projects` (with their estimation revisions) feed the Bid Table's
  // budgeted-cost column, exactly like on the MCS page.
  const { plantId, bidId: mrqId } = useParams();
  const [plant, setPlant] = useState({
    id: plantId ?? "",
    projects: [],
  });
  const [openChatVendorIndex, setOpenChatVendorIndex] = React.useState("");
  const [mrqData, setMrqData] = React.useState({});
  console.log("after mrqData: ---------------------", mrqData);

  const [mrqSelection, setMrqSelection] = React.useState({
    selectedMrq: "",
    revisions: [],
    selectedRevision: "",
  });
  const [BidTableRows, setBidTableRows] = React.useState();
  const [bidData, setBidData] = React.useState();
  const [selectedBidVendors, setSelectedVendors] = React.useState([]);
  const [createdPos, setCreatedPos] = useState([]);

  // Same plant payload the MCS page loads (see MCS.context's fetchPlant),
  // then the MRQ named in the URL with that plant loaded so the Bid Table
  // rows carry their budgeted-cost data.
  React.useEffect(() => {
    const fetchPlant = async () => {
      let plantData = plant;
      try {
        const res = await secondAxios.get("/plant/" + plantId + "/mcs");
        plantData = { ...plant, ...res.data };
        setPlant(plantData);
      } catch (err) {
        console.error("Error fetching plants:", err);
      }

      if (mrqId) {
        fetchMrqThenBidData({
          plant: plantData,
          mrqSelection: { selectedMrq: mrqId },
          setBidData,
          setBidTableRows,
          setSelectedBidMrqData: setMrqData,
        });
        setMrqSelection({ ...mrqSelection, selectedMrq: mrqId });
      }
    };

    fetchPlant();
  }, []);

  React.useEffect(() => {
    setSelectedVendors(mrqData?.vendors?.map((v) => v.name));
  }, [mrqData?.vendors]);

  React.useEffect(() => {
    const revisions = mrqData?.revs ? mrqData.revs : [];

    setMrqSelection({
      selectedMrq: mrqData?.id,
      revisions,
      selectedRevision: mrqData?.id,
    });
  }, []);

  React.useEffect(() => {
    fetchMrqThenBidData({
      plant,
      mrqSelection,
      setBidData,
      setBidTableRows,
      setSelectedBidMrqData: setMrqData,
    });
  }, [mrqSelection.selectedRevision, mrqSelection.selectedMrq]);

  const vendors = mrqData?.vendors;
  return (
    <BidContext.Provider
      value={{
        plant,
        vendors: vendors || [],
        openChatVendorIndex,
        setOpenChatVendorIndex,

        mrqData,
        mrqSelection,
        setMrqSelection,
        setSelectedBidMrqData: setMrqData,

        bidData,
        BidTableRows,
        setBidTableRows,

        selectedBidVendors,
        setSelectedVendors,

        createdPos,
        setCreatedPos,
      }}
    >
      {children}
    </BidContext.Provider>
  );
}

export { BidContextProvider, BidContext };